export class DmsDocumentResp {
  imageBytes: Uint8Array;
}
